module.exports = __webpack_public_path__ + "static/images/containers/BuildingCard/components/ReserveProduce/images/divider-shadowed.b03075a5.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingCard/components/ReserveProduce/images/divider-shadowed.png
// module id = 2804
// module chunks = 11